import { NgModule } from '@angular/core';
import { NbAutocompleteModule, NbButtonModule, NbCardModule, NbCheckboxModule, NbContextMenuModule, NbDatepickerModule, NbInputModule, NbLayoutModule, NbListModule, NbMenuModule, NbRadioModule, NbSelectModule, NbTimepickerModule } from '@nebular/theme';

import { ThemeModule } from '../@theme/theme.module';
import { PagesComponent } from './pages.component';
import { PagesRoutingModule } from './pages-routing.module';
import { MiscellaneousModule } from './miscellaneous/miscellaneous.module';
import { SalesComponent } from './sales/sales.component';
import { BartendersComponent } from './bartenders/bartenders.component';
import { UsersComponent } from './users/users.component';
import { MarketingComponent } from './marketing/marketing.component';
import { EventdetailsComponent } from './eventdetails/eventdetails.component';
import { GeneratorComponent } from './generator/generator.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Angular2SmartTableModule } from 'angular2-smart-table';
import { ManagersComponent } from './managers/managers.component';
import { PricelistComponent } from './pricelist/pricelist/pricelist.component';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { TokengeneratorComponent } from './tokengenerator/tokengenerator.component';
import { NgxCumulioDashboardModule } from '@cumul.io/ngx-cumulio-dashboard';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { SalesdetailComponent } from './salesdetail/salesdetail.component';
import { InvoicerequestsComponent } from './invoicerequests/invoicerequests.component';
import { HorecaTouchComponent } from './horeca-touch/horeca-touch.component';


@NgModule({
  imports: [
    PagesRoutingModule,
    ThemeModule,
    NbMenuModule,
    NbCardModule,
    NbSelectModule,
    NbInputModule,
    NbCheckboxModule,
    NbRadioModule,
    NbLayoutModule,
    NbButtonModule,
    NbAutocompleteModule,
    Angular2SmartTableModule,
    NbContextMenuModule,
    NbListModule,
    FormsModule,
    SweetAlert2Module,
    ReactiveFormsModule,
    MiscellaneousModule,
    NbDatepickerModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NgxQRCodeModule,
    NgxCumulioDashboardModule
  ],
  declarations: [
    PagesComponent,
    SalesComponent,
    BartendersComponent,
    UsersComponent,
    MarketingComponent,
    EventdetailsComponent,
    GeneratorComponent,
    ManagersComponent,
    PricelistComponent,
    TokengeneratorComponent,
    SalesdetailComponent,
    InvoicerequestsComponent,
    HorecaTouchComponent,
  ],
})
export class PagesModule {
}
